<template>
  <bm-btn :id="activatorId" v-bind="$attrs" :data-qa="$m.keys.more">
    <!-- This uses a selected activator as the button is already connected to a tooltip activator (slot style activator) -->
    <v-menu offset-y :activator="'#' + activatorId" :top="top">
      <v-list data-qa="bm-btn-dropdown-list">
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          link
          :to="item.to"
          :class="{ 'hide-list-element': item.hidden }"
          :disabled="item.disabled"
          @click="!item.to && item.action && item.action($event, item.item)"
        >
          <v-list-item-title>
            <v-icon v-if="item.icon">{{ item.icon }}</v-icon>
            <v-icon
              v-else-if="item.iconConfig"
              :size="item.iconConfig.width"
              :style="{ height: item.iconConfig.height }"
              :class="item.iconConfig.class"
            />
            {{ item.text }}
          </v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
    <div style="width: 100%">
      <slot />
    </div>
    <v-icon v-if="!footer">expand_more</v-icon>
  </bm-btn>
</template>

<script lang="ts">
import type { PropType } from "vue";
import { defineComponent } from "vue";
import { getUniqueId } from "@/components/composables/unique";
import type { BmBtnDropdownMenuItem } from "@/components/controls/input/types/BmBtnDropdownTypes";

export default defineComponent({
  name: "BmBtnDropdown",
  props: {
    items: {
      type: Array as PropType<BmBtnDropdownMenuItem[]>,
      required: true,
    },
    top: {
      type: Boolean,
      required: false,
      default: false,
    },
    footer: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup() {
    return {
      // unique id to assign to the button and attach the activator to.
      activatorId: getUniqueId(),
    };
  },
});
</script>

<style lang="sass" scoped>
.hide-list-element
  display: none !important
</style>
